import { translatableFactory } from '@ackee/jerome/antd';
import { intlData, antdData } from '../config';

export default translatableFactory(intlData, antdData);
